import { render, staticRenderFns } from "./BugReportForm.vue?vue&type=template&id=197b36de&scoped=true"
import script from "./BugReportForm.vue?vue&type=script&lang=js"
export * from "./BugReportForm.vue?vue&type=script&lang=js"
import style0 from "./BugReportForm.vue?vue&type=style&index=0&id=197b36de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197b36de",
  null
  
)

export default component.exports